import React from "react";
import { useScheduleData, UseScheduleDataReturn } from "../scheduleData";

interface ServiceTypesInfoProps {
  isDarkMode?: boolean;
}

export function ServiceTypesInfo({
  isDarkMode = false,
}: ServiceTypesInfoProps) {
    const s = useScheduleData();
    const { serviceTypesInfo = [] } = (s || {}) as Partial<UseScheduleDataReturn>;
    
  return (
    <div
      className={`rounded-lg border p-4 transition-colors duration-300 ${
        isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-200"
      }`}
    >
      <h4
        className={`text-sm font-semibold mb-3 transition-colors duration-300 ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}
      >
        Service Types
      </h4>
      <div className="grid grid-cols-2 gap-3">
        {serviceTypesInfo
  .filter(service => service.serviceType !== 1 && service.serviceType !== 3)
  .map(service => (
          <div key={service.name} className="space-y-1">
            <div className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full ${service.color}`}></div>
              <span
                className={`text-sm font-medium transition-colors duration-300 ${
                  isDarkMode ? "text-white" : "text-gray-900"
                }`}
              >
                {service.label}
              </span>
            </div>
            <div
              className={`text-xs ml-5 transition-colors duration-300 ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              {service.serviceDuration} min
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
